import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=534f1bf6&scoped=true"
import script from "./TheHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=534f1bf6&prod&scoped=true&lang=scss"
import style1 from "./TheHeader.vue?vue&type=style&index=1&id=534f1bf6&prod&lang=scss"
import style2 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f1bf6",
  null
  
)

export default component.exports